/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Category_OperationsInputs */

const en_blog_category_operations = /** @type {(inputs: Blog_Category_OperationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operations`)
};

const lv_blog_category_operations = /** @type {(inputs: Blog_Category_OperationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikdienas darbs`)
};

/**
* | output |
* | --- |
* | "Operations" |
*
* @param {Blog_Category_OperationsInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_category_operations = /** @type {((inputs?: Blog_Category_OperationsInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Category_OperationsInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_category_operations(inputs)
	return en_blog_category_operations(inputs)
});